import { FC } from 'react';
import { Redirect } from 'react-router';

import Stepper from 'components/Stepper';
import { StepOptions } from 'components/Stepper/types';
import SetupBudgetCard from 'features/PaymentCards/pages/RequestNewCard/steps/SetupBudgetCard';
import { PaymentCardType } from 'types/creditCard';

import {
  RequestNewCardContextProvider,
  useRequestNewCardContext,
} from './hooks/useRequestNewCardContext';
import ConfirmPinCode from './steps/ConfirmPinCode';
import Ordering from './steps/Ordering';
import SelectCard from './steps/SelectCard';
import SelectPinCode from './steps/SelectPinCode';

const RequestNewCardStepper: FC = () => {
  const { sharedState } = useRequestNewCardContext();

  const steps: StepOptions[] = [
    {
      key: 'select-card',
      render: (props) => <SelectCard {...props} />,
    },
  ];

  if (sharedState.isBudgetCard) {
    steps.push({
      key: 'setup-budget-card',
      render: (props) => <SetupBudgetCard {...props} />,
    });
  }

  if (sharedState.cardType === PaymentCardType.PHYSICAL) {
    steps.push(
      {
        key: 'select-pin-code',
        render: (props) => <SelectPinCode {...props} />,
      },
      {
        key: 'confirm-pin-code',
        render: (props) => <ConfirmPinCode {...props} />,
      },
    );
  }

  steps.push({
    key: 'ordering',
    render: (props) => <Ordering {...props} />,
  });

  steps.push({
    key: 'request-new-card-confirmation',
    render: () => <Redirect to="/cards/" />,
  });

  return <Stepper steps={steps} />;
};

const RequestNewCard: FC = () => (
  <RequestNewCardContextProvider>
    <RequestNewCardStepper />
  </RequestNewCardContextProvider>
);

export default RequestNewCard;
